export const RADIUS = [0, 0.25, 0.375, 0.5, 0.625, 0.75, 1] as const
